<template>
  <header class="OSidebar-header relative">
    <OButtonSideMenu @click:btn-side="$emit('click:btn-side')" />
    <q-card
      class="bg-white/5 border-b border-white/5 !shadow-none !rounded-none h-[12.8125rem]"
    >
      <div
        class="relative flex items-center gap-8 pt-16 pb-8 px-8 flex-nowrap h-[80px]"
      >
        <q-skeleton
          v-if="loading.menu"
          class="size-56 rounded-full absolute top-16 left-10"
        />

        <q-circular-progress
          v-else
          show-value
          font-size="10px"
          :value="+progress"
          size="56px"
          :thickness="0.3"
          color="primary-pure"
          track-color="white"
          class="CustomProgress text-caps-3 text-neutral-30 absolute top-16 left-10"
        >
          {{ menu.respondidas_total }}

          <q-tooltip
            anchor="center right"
            self="center left"
            :offset="[10, 10]"
          >
            {{ progress }}%
          </q-tooltip>
        </q-circular-progress>

        <div
          class="flex items-center gap-4 flex-nowrap p-8 ml-72 my-auto Nv0-text"
        >
          <RouterLink
            :to="{
              name: 'pergunta',
              params: { id: menu.proxima_pergunta },
            }"
            class="text-headline-3 text-white !p-0"
            @click="closeMenu"
          >
            {{ t('continueWhereI') }}
          </RouterLink>
          <q-icon
            class="w-24 h-24 text-primary-pure"
            name="chevron_right"
          />
        </div>
      </div>

      <div
        class="h-[124px] flex flex-col justify-center gap-8 px-16 pb-10 Nv0-text"
      >
        <h2 class="text-headline-2 text-white !text-wrap">
          {{ menu.nome_fantasia }}
        </h2>
        <img
          v-if="menu.logo_png"
          :src="menu.logo_png"
          :alt="menu.nome_fantasia"
          class="CustomFilter w-fit h-40 object-contain"
        />
        <p class="text-paragraph-3 text-neutral-2 !text-wrap">
          {{ menu.subtitulo }}
        </p>
      </div>
    </q-card>

    <OButton
      v-if="Screen.lt.md"
      primary
      class="w-32 h-32 p-0 !bg-primary-light"
      :class="{ 'opacity-0 invisible': !Screen.lt.md }"
      @click="closeMenu"
    >
      <q-icon class="w-32 h-32" name="svguse:#icon_close" />
    </OButton>
  </header>
</template>

<script setup>
import { computed, inject } from 'vue'
import { Screen } from 'quasar'
import { useI18n } from 'vue-i18n'
import OButton from 'components/Button/OButton.vue'
import OButtonSideMenu from 'components/Button/OButtonSideMenu.vue'

const { t } = useI18n()

/** @typedef {import('../../types/menu').MenuTypes} MenuTypes */

/** @type {{menu:MenuTypes}}  */
const { menu, loading } = defineProps({
  menu: Object,
  loading: Object,
  closeMenu: Function,
})

const progress = computed(() => {
  if (!menu.respostas_assessment_porcentagem) return 0
  return menu.respostas_assessment_porcentagem
})

const emits = defineEmits(['click:btn-side'])
</script>

<style lang="scss" scoped>
.CustomProgress :deep(.q-circular-progress__track) {
  stroke: rgba(255, 255, 255, 0.1);
}

.CustomFilter {
  filter: grayscale(1) contrast(150%) invert(1);
}
</style>
